import { Button } from "@legal-500/legal500-design-system";
import type { FirmLogoFillExportFormat } from "../../../api/firmLogoFill.service.js";
import styles from "./FirmLogoCopy.module.css";

type FirmLogoCopyDownloadsProps = {
  exportingFormat: FirmLogoFillExportFormat | null;
  onDownload: (format: FirmLogoFillExportFormat) => void;
};

export function FirmLogoCopyDownloads({ exportingFormat, onDownload }: FirmLogoCopyDownloadsProps) {
  return (
    <div className={styles.downloads}>
      <Button
        type="button"
        variant="outlined"
        disabled={exportingFormat !== null}
        onClick={() => onDownload("csv")}
      >
        {exportingFormat === "csv" ? "Preparing…" : "Download CSV"}
      </Button>
      <Button
        type="button"
        variant="outlined"
        disabled={exportingFormat !== null}
        onClick={() => onDownload("json")}
      >
        {exportingFormat === "json" ? "Preparing…" : "Download JSON"}
      </Button>
    </div>
  );
}
